<template lang="pug">
  el-input.social-handle-input(
    ref="input"
    v-model="proxy"
    v-bind="$attrs"
    :class="{ 'no-prepend': !icon }")
    span(slot="prepend" v-if="icon" @click="select")
      i.bx(:class="icon" v-tooltip.left="name")

    span(slot="prefix" v-if="prefix" @click="select") {{ prefix }}

    span(slot="append" v-if="url")
      a(
        :href="url"
        target="_blank"
        rel="noopener"
        title="Open in new tab")
        i.bx.bx-link-external
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },

    icon: {
      type: String,
      default: null
    },

    prefix: {
      type: String,
      default: null
    },

    suffix: {
      type: String,
      default: null
    },

    linked: {
      type: Boolean,
      default: false
    },

    name: {
      type: String,
      default: null
    }
  },

  computed: {
    proxy: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    },

    url () {
      if (!this.linked) return null
      if (this.proxy.trim().length <= 0) return null
      const url = [
        this.prefix,
        this.proxy,
        this.suffix
      ].filter(i => i?.length > 0).join('')

      return url.startsWith('https://') ? url : `https://${url}`
    }
  },

  methods: {
    select () {
      const input = this.$refs.input
      if (typeof input?.select === 'function') input.select()
    }
  }
}
</script>

<style lang="scss" scoped>
.social-handle-input {
  border: $--border-light;
  border-radius: $--radius;
  &:has(input:focus) {
    border-color: $--color-primary;
  }
  &.no-prepend {
    ::v-deep {
      .el-input__inner {
        padding-left: 15px;
      }
    }
  }
  ::v-deep() {
    display: flex;
    gap: 0;
    > * {
      position: relative;
      line-height: 40px;
    }
    .el-input-group__prepend,
    .el-input-group__append {
      width: 40px;
      min-width: 40px;
      flex: 0 40px;
      padding: 0;
      font-size: 0;
      line-height: 0;
      border: none;
      i {
        font-size: 24px;
        line-height: 40px;
        text-align: center;
        width: 100%;
        color: $--color-primary;
      }
    }
    .el-input-group__append {
      background: none;
      width: 32px;
      min-width: 32px;
      flex: 0 32px;
      order: 2;
      i {
        font-size: 16px;
      }
    }
    .el-input__prefix {
      left: 0;
      white-space: nowrap;
      order: 1;
      width: fit-content;
      min-width: fit-content;
      transform: none !important;
      overflow: visible;
      padding: 0 4px 0 12px;
      color: lighten($--color-text-secondary, 20);
      user-select: none;
    }
    .el-input__inner {
      order: 2;
      border: none;
      padding-left: 0;
      flex: 1;
    }
  }
}
</style>
<style lang="scss">
.el-form-item.is-error {
  .social-handle-input,
  .social-handle-input:has(input:focus) {
    border-color: #e5285d;
    .el-input-group__append {
      visibility: hidden;
    }
  }
}
</style>
